module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cancer/cnc_gc-259df50c6678dea6c490be54bc16bbb5.gif";